import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { MagnifyingGlass, ArrowLeft, ArrowRight, QrCode } from "@phosphor-icons/react";

export default function SearchPage() {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const search = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/public/search", { params: { q } });
      setResults(data);
    } finally { setLoading(false); }
  };

  useEffect(() => { search(); /* initial */ /* eslint-disable-next-line */ }, []);

  return (
    <div style={{ minHeight: "100vh", background: "#fff" }}>
      <div style={{ borderBottom: "1px solid var(--border)" }}>
        <div style={{ maxWidth: 900, margin: "0 auto", padding: "16px 24px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Link to="/" className="btn btn-ghost" data-testid="search-back-home"><ArrowLeft size={14} /> Home</Link>
          <Link to="/" style={{ display: "flex", gap: 8, alignItems: "center", color: "#000", textDecoration: "none" }}>
            <div style={{ width: 24, height: 24, background: "#000", display: "grid", placeItems: "center" }}>
              <QrCode size={14} color="#fff" weight="bold" />
            </div>
            <span className="font-display" style={{ fontWeight: 800, fontSize: 14 }}>7AuraDigital</span>
          </Link>
        </div>
      </div>

      <div style={{ maxWidth: 900, margin: "0 auto", padding: "48px 24px" }}>
        <div className="overline">Browse</div>
        <h1 className="font-display" style={{ fontSize: 56, fontWeight: 900, letterSpacing: "-0.03em", margin: "8px 0 24px", lineHeight: 1 }}>
          Search information pages
        </h1>
        <div style={{ display: "flex", gap: 8 }}>
          <div style={{ flex: 1, position: "relative" }}>
            <MagnifyingGlass size={18} style={{ position: "absolute", left: 14, top: 15, color: "var(--text-2)" }} />
            <input className="input" placeholder="Search by title, tag, city, category…"
              value={q} onChange={(e) => setQ(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && search()}
              data-testid="search-input"
              style={{ paddingLeft: 42, fontSize: 16, padding: "14px 16px 14px 42px" }} />
          </div>
          <button className="btn btn-primary" onClick={search} data-testid="search-submit" style={{ padding: "0 22px" }}>Search</button>
        </div>

        <div style={{ marginTop: 40 }}>
          {loading ? <div className="skel" style={{ height: 120 }} /> :
           results.length === 0 ? <div style={{ color: "var(--text-2)" }}>No results.</div> :
           <div style={{ display: "grid", gap: 16 }}>
             {results.map((p) => (
               <Link key={p.id} to={`/p/${p.slug}`} data-testid={`search-result-${p.id}`}
                 style={{ display: "grid", gridTemplateColumns: "160px 1fr", gap: 20, padding: 16, border: "1px solid var(--border)", textDecoration: "none", color: "#000", alignItems: "center" }}>
                 {p.featured_image ? (
                   <img alt="" src={p.featured_image} style={{ width: "100%", height: 110, objectFit: "cover" }} />
                 ) : (
                   <div style={{ background: "var(--surface)", height: 110, display: "grid", placeItems: "center", color: "var(--text-2)" }}>
                     <QrCode size={32} weight="duotone" />
                   </div>
                 )}
                 <div>
                   {p.category && <div className="overline">{p.category}</div>}
                   <div className="font-display" style={{ fontSize: 22, fontWeight: 800, marginTop: 4 }}>{p.title}</div>
                   <div style={{ color: "var(--text-2)", marginTop: 4, fontSize: 14 }}>{p.short_description}</div>
                   <div style={{ marginTop: 8, display: "flex", gap: 6, flexWrap: "wrap" }}>
                     {(p.tags || []).slice(0, 5).map((t) => <span key={t} className="badge badge-muted">#{t}</span>)}
                   </div>
                 </div>
               </Link>
             ))}
           </div>
          }
        </div>
      </div>
    </div>
  );
}
